import { Typography, styled } from '@mui/material';

export const ToggleListContainer = styled('div')(() => ({
  width: '100%',
  display: 'flex',
}));

export const ListTitle = styled(Typography)(() => ({
  width: '50%',
  padding: '15px 0px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
